var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "products__category-header" }, [
    _c("a", {
      ref: "anchor",
      staticClass: "anchor",
      attrs: { id: "category-" + _vm.category.code }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "products__category-header-bg" }, [
      _c("img", {
        staticClass: "products__category-header-bg-image",
        attrs: {
          src: _vm.category.headerImage,
          alt: "category header image",
          loading: "lazy"
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "products__category-header-content" },
      [
        _vm.iconComponent(_vm.category.svgIconKey)
          ? _c(_vm.iconComponent(_vm.category.svgIconKey), {
              tag: "component",
              staticClass: "products__category-header-icon"
            })
          : _c("SVGInfo", { staticClass: "products__category-header-icon" }),
        _vm._v(" "),
        _c("h2", {
          staticClass: "products__category-header-title",
          domProps: { innerHTML: _vm._s(_vm.category.name) }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }